var _circle, _path, _path2, _path3, _path4, _path5, _path6, _path7;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconCheckout(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "#0EA0F2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.2107 12.3537V11.5368C12.2107 9.64211 13.7349 7.78106 15.6296 7.60422C17.8865 7.38527 19.7896 9.16211 19.7896 11.3768V12.539",
    stroke: "white",
    strokeWidth: 1.01053,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4741 24.4211H18.5268C21.912 24.4211 22.5183 23.0653 22.6952 21.4147L23.3268 16.3621C23.5541 14.3074 22.9647 12.6316 19.3689 12.6316H12.632C9.03623 12.6316 8.44676 14.3074 8.67413 16.3621L9.30571 21.4147C9.48255 23.0653 10.0889 24.4211 13.4741 24.4211Z",
    stroke: "white",
    strokeWidth: 1.01053,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.9438 16H18.9513",
    stroke: "white",
    strokeWidth: 1.26316,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.0483 16H13.0558",
    stroke: "white",
    strokeWidth: 1.26316,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M16.0003 21.8948C16.0003 22.8422 15.735 23.7391 15.2676 24.497C15.0276 24.9012 14.7371 25.2675 14.396 25.558C14.3582 25.6085 14.3203 25.6464 14.2698 25.6843C13.3856 26.4801 12.2234 26.9474 10.9477 26.9474C9.4066 26.9474 8.02972 26.2526 7.12025 25.1663C7.09498 25.1284 7.05716 25.1032 7.03189 25.0653C6.88031 24.8885 6.74136 24.6991 6.62767 24.497C6.1603 23.7391 5.89502 22.8422 5.89502 21.8948C5.89502 20.3032 6.62765 18.8759 7.78976 17.9537C8.00449 17.7769 8.23183 17.6253 8.47183 17.499C9.20447 17.0822 10.0508 16.8422 10.9477 16.8422C12.2108 16.8422 13.3476 17.2969 14.2318 18.0674C14.3834 18.1811 14.5224 18.3201 14.6487 18.459C15.4824 19.3685 16.0003 20.5685 16.0003 21.8948Z",
    fill: "#0EA0F2",
    stroke: "white",
    strokeWidth: 1.01053,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4743 21.8948H8.42163",
    stroke: "white",
    strokeWidth: 1.01053,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9478 19.3685V24.4212",
    stroke: "white",
    strokeWidth: 1.01053,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCheckout);
export default __webpack_public_path__ + "static/media/icon-checkout.dcfc9a239c1276e495bb910b92b9a1ef.svg";
export { ForwardRef as ReactComponent };